import gql from "graphql-tag";
import {FetchResult} from "apollo-link"
import * as toastr from 'toastr';
import {client} from "./client";
import {IContactNode} from "../types";
import {UpdateContactByPocid} from "../../schema/UpdateContactByPocid";

const getMutation = (pocid: number, contactPatch: {[key: string]: any}) => ({
    mutation: gql`${UpdateContactByPocid}`,
    variables: {
        pocid,
        contactPatch,
    }
});

export async function updateContactByPocid (pocid: number, patchObject: {[key: string]: any}):
    Promise<IContactNode> {
    const result: FetchResult<{ updateContactByPocid: { contact: IContactNode } }> = await client.mutate(getMutation(pocid, patchObject));
    const {contact} = result.data?.updateContactByPocid!;
    if (!contact) {
        toastr.error(`Failed to update contact ${pocid}`);
        throw new Error('failed to update contact');
    } else {
        toastr.success(`Updated contact ${contact.name}`);
        client.cache.reset();
        return contact;
    }
}
